import { useMemo } from "react";
import { useOnboardingData } from "../components/Portfolio/Onboarding/useOnboardingData";
import { getAgentDataMap } from "../components/Chat/const";

export const useAgentThinking = () => {
  const agentDataMap = getAgentDataMap();
  const { apiAgentsData } = useOnboardingData();

  const agentsObj = useMemo(() => {
    if (!Array.isArray(apiAgentsData)) {
      return {};
    }

    return apiAgentsData.reduce<
      Record<string, (typeof agentDataMap)[keyof typeof agentDataMap]>
    >((acc, rawAgent) => {
      const agent = rawAgent as any;
      const { label, description, name } = agent;

      if (!label) {
        return acc;
      }

      acc[label] = {
        ...agentDataMap[label],
        desc: description,
        name,
        title: name,
      };

      return acc;
    }, {});
  }, [agentDataMap, apiAgentsData]);

  const allAgentDataMap = {
    ...agentDataMap,
    ...agentsObj,
  };

  return {
    agentDataMap: allAgentDataMap,
    agentKeys: Object.keys(allAgentDataMap),
  };
};
